import { Col, Row } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import ShipmentDetailDrawer from '../../components/drawers/ShipmentDetailDrawer';
import { useShipmentDetailDrawerStyles } from '../../components/drawers/ShipmentDetailDrawer.styles';
import { DRAWER_MEDIA_MAPPER } from '../../components/drawers/drawerCommon';
import { InnerContentScrollbars } from '../../components/layout/InnerContentScrollbars';
import { LabelWithValue } from '../../components/typography';
import { cssVariables } from '../../styles/cssVariables';
import { pxToNumber } from '../../utils/cssUtils';
import { useShipmentAssetsInventoryStyles } from './ShipmentAssetsInventory.styles';

const StyledLabelWithValue = props => (
  <LabelWithValue {...props} size="xs" labelSize="full" nowrap />
);

function AssetEntry({ data, index }) {
  const gutter = pxToNumber(cssVariables.spaceNorm);
  const { styles } = useShipmentAssetsInventoryStyles();

  return (
    <div
      className={classNames(styles.assetsInventoryEntry, {
        'odd-index': index % 2 === 0,
        'even-index': index % 2 === 1,
      })}
    >
      <Row align="stretch" gutter={gutter}>
        <Col className={styles.col1}>
          <StyledLabelWithValue
            className={styles.assetEntryLabel}
            labelId="shipmentDetail.inventoryDrawer.description"
            text={data.description}
          />
        </Col>
        <Col className={styles.cols23}>
          <Row align="top" gutter={gutter}>
            <Col className={styles.col2}>
              <StyledLabelWithValue
                className={styles.assetEntryLabel}
                labelId="shipmentDetail.inventoryDrawer.partNumber"
                text={data.partNumber}
              />
            </Col>
            <Col className={styles.col3}>
              <StyledLabelWithValue
                className={styles.assetEntryLabel}
                labelId="shipmentDetail.inventoryDrawer.assetTagNumber"
                text={data.assetTagNumber}
              />
            </Col>
          </Row>
          <Row align="top" gutter={gutter}>
            <Col className={styles.col2}>
              <StyledLabelWithValue
                className={styles.assetEntryLabel}
                labelId="shipmentDetail.inventoryDrawer.serialNumber"
                text={data.serialNumber}
              />
            </Col>
            <Col className={styles.col3}>
              <StyledLabelWithValue
                className={styles.assetEntryLabel}
                labelId="shipmentDetail.inventoryDrawer.poNumber"
                text={data.poNumber}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export function ShipmentAssetsInventoryDrawer({ isOpen, close, data }) {
  const { styles } = useShipmentDetailDrawerStyles();
  const { styles: inventoryStyles } = useShipmentAssetsInventoryStyles();

  return (
    <ShipmentDetailDrawer
      open={isOpen}
      onClose={close}
      header={<FormattedMessage id="shipmentDetail.inventoryDrawer.header" />}
      className={styles.assetsInventoryDrawer}
    >
      <InnerContentScrollbars mediaMapper={DRAWER_MEDIA_MAPPER}>
        <div className={inventoryStyles.assetsInventory}>
          {(data || []).map((asset, i) => (
            // Items are static, so there is no problem in using index as key
            // eslint-disable-next-line react/no-array-index-key
            <AssetEntry key={i} index={i} data={asset} />
          ))}
        </div>
      </InnerContentScrollbars>
    </ShipmentDetailDrawer>
  );
}
